import { makeRandomAlphaNumeric } from 'zoomforth_zfutils/random.js';

const EID_CHAR_COUNT = 7;
const MENU_ITEM_ID_CHAR_COUNT = 5;
const SECTION_ID_CHAR_COUNT = 5;
const GRID_TAXONOMY_ID_CHAR_COUNT = 5;

export const generateEid = () =>
  makeRandomAlphaNumeric(EID_CHAR_COUNT);

export const generateMenuItemId = () =>
  makeRandomAlphaNumeric(MENU_ITEM_ID_CHAR_COUNT);

export const generateSectionId = () =>
  makeRandomAlphaNumeric(SECTION_ID_CHAR_COUNT);

export const generateGridTaxonomyCategoryId = ()=>
  makeRandomAlphaNumeric(GRID_TAXONOMY_ID_CHAR_COUNT);

export const generateGridTaxonomyTagId = ()=>
  makeRandomAlphaNumeric(GRID_TAXONOMY_ID_CHAR_COUNT);
